import { Action } from "../Action";

const development: boolean = process.env.NODE_ENV && process.env.NODE_ENV === "development";

export function isDev(): boolean {
    return development;
}

export function logDispatchedAction(state: any, action: Action): void {
    if (!isDev()) return;
    console.log(
        `
%cAction Dispatched: %c%s
%cCurrent State: %O
Payload: %O
    `,
        "font-weight: bold",
        "font-weight: bold; color: red;",
        action.type,
        "font-weight: normal",
        state,
        action.payload
    );
}
